import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import axios from 'axios';
// import Header from 'components/ui/Header';
import { Link } from 'react-router-dom';
// import TextField from './TextField';
import Select from 'react-select';
import ToggleDropdown from './ToggleDropdown';
import { Client, DropdownOption } from './types';
import { Modal } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { useOrderEntry } from './OrderEntryContext';
import TextField from './ui/TextField';
import { useUserContext } from '../../context/UserContext';
import qs from 'qs';
import DuplicateTitleModal from './DuplicateTitleModal';
const DuplicateTitle = styled.div`
  font-size: 11px;
  position: absolute;
  top: 80px;
  left: 0px;
`;
const ErrorText = styled.div`
  font-size: 13px;
  color: #c50e29;
`;
const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    marginTop: 8,
    width: 230,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #f5f5f5',
    //   boxShadow: state.isFocused && '1px solid #ff5252',
    //   border: state.isFocused && '1px solid #ff5252',
    height: 48,
    //   '&:hover': {
    //     border: state.isFocused && '1px solid #ff5252',
    //   },
  }),
};
const toggleOptions = [
  { value: 0, label: 'Priority: Regular' },
  { value: 1, label: 'Priority: Rush' },
  { value: 2, label: 'Priority: Super Rush' },
];

const OrderDetails = () => {
  const [clientJvs, setClientJvs] = useState([]);
  const [numCheckLoaderStatus, setNumCheckLoaderStatus] = useState(false);
  const [titleNumExistsOrderId, setTitleNumExistsOrderId] = useState(false);
  const [showTitleExistsModal, setShowTitleExistsModal] = useState(false);

  const { titleNumber, setTitleNumber, setPriority, priority, errors, setSelectedClient, selectedClient } =
    useOrderEntry();
  const { user } = useUserContext();

  useEffect(() => {
    if (user.clientId)
      axios.get(`/api/clientaccount/getClientAndJvs/${user.clientId}`).then(({ data }) => {
        const mappedData = data.map(jv => ({ value: jv.id, label: jv.name }));
        setClientJvs(mappedData);
        setSelectedClient(mappedData.find(d => d.value === user.clientId));
      });
  }, [user?.clientId]);
  const handleTitleNumber = async () => {
    setNumCheckLoaderStatus(true);
    const queryString = qs.stringify({ titleNumber, clientId: user.clientId });
    const { data } = await axios.get(`/api/clientOrder/TitleNumExistsForClient?${queryString}`);

    setTitleNumExistsOrderId(data > 0 ? data : null);
    setShowTitleExistsModal(data > 0 ? data : null);
    setNumCheckLoaderStatus(false);
  };
  return (
    <div style={{ display: 'flex', marginLeft: '15%' }}>
      <div style={{ fontWeight: 'bold', width: 200, fontSize: 24 }}>New Order</div>
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextField
          name="titleNumber"
          label="Title number"
          width="230"
          value={titleNumber}
          styles={{ marginRight: 16 }}
          onChange={(e: any) => {
            setTitleNumber(e.target.value);
          }}
          onBlur={handleTitleNumber}
        />
        {titleNumExistsOrderId && (
          <DuplicateTitle>
            {/* <Link to={`/order/${titleNumExistsOrderId}`} style={{ textDecoration:'underline' }}>
              Duplicate Title
            </Link> */}
            <a href={`/order/${titleNumExistsOrderId}`} target={'_blank'} style={{ textDecoration:'underline' }} rel="noreferrer">Open duplicate title</a>
          </DuplicateTitle>
        )}
        {errors?.titleNumber && <ErrorText>{errors?.titleNumber}</ErrorText>}
      </div>

      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          // gap: 4,
          marginRight: 24,
          marginLeft: 16,
        }}
      >
        {/* {clientJvs.length <= 1 && (
          <p style={{ marginBottom: 8, display: 'inline-block' }}>Client: {selectedClient?.label}</p>
        )} */}

        {clientJvs.length > 1 && (
          <>
            <div>Company</div>
            <Select
              name="selectedClient"
              value={selectedClient}
              options={clientJvs}
              onChange={client => setSelectedClient(client)}
              styles={customStyles}
              components={{
                IndicatorSeparator: null,
              }}
            />
          </>
        )}
      </div>
      <div style={{ marginTop: 28 }}>
        <ToggleDropdown
          options={toggleOptions}
          name="priorities"
          value={priority}
          onChange={(p: any) => {
            setPriority(p);
          }}
          components={{
            IndicatorSeparator: null,
          }}
        />
      </div>
      {/* <Modal
        open={showTitleExistsModal}
        onClose={() => setShowTitleExistsModal(false)}
        closeIcon
        size="small"
      >
        <Modal.Content>
          <h4>Title Number already exists</h4>
          <Link to={`/order/${titleNumExistsOrderId}`}>Go to order</Link>
        </Modal.Content>
      </Modal> */}
      <DuplicateTitleModal
        onClose={() => setShowTitleExistsModal(false)}
        openState={showTitleExistsModal}
        titleNumExistsOrderId={titleNumExistsOrderId}
      />
    </div>
  );
};

export default OrderDetails;
